export const plpDataLocators = {
    plp_no_results: 'plp_no_results',
    plp_toggle_switch: 'plp_toggle_switch',
    plp_show_unavailable_products: 'plp_show_unavailable_products'
};
